import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CashRegisterData, Purchase } from "@/types";
import { toast } from "react-toastify";
import {
  createCashRegister,
  fetchCashRegister,
  patchCashChange,
  patchCashClose,
  patchCashWithdrawal,
} from "./thunk";

interface PaginatedCashier {
  data: CashRegisterData;
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface CashierState {
  cashier: PaginatedCashier;
  loading: boolean;
  error: string | null;
}

const initialState: CashierState = {
  cashier: {
    data: {
      cashRegisters: [],
      sales: [],
    },
  },
  loading: false,
  error: null,
};

const CashierSlice = createSlice({
  name: "Cashier",
  initialState,
  reducers: {
    clearCashier: (state) => {
      state.cashier = {
        data: {
          cashRegisters: [],
          sales: [],
        },
        total: 0,
        currentPage: 1,
        perPage: 10,
      };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchCashRegister.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchCashRegister.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          const payload = action.payload;

          if (Array.isArray(payload.data)) {
            // Dados não paginados
            state.cashier = {
              data: { cashRegisters: payload.data, sales: [] },
            };
          } else {
            // Dados paginados
            state.cashier = {
              data: payload.data,
              total: payload.data.total,
              currentPage: payload.data.current_page,
              perPage: payload.data.per_page,
            };
          }
        },
      )
      .addCase(fetchCashRegister.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })
      // Create
      .addCase(createCashRegister.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        createCashRegister.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          //state.purchases.data.push(action.payload.data);
          toast.success("O caixa foi aberto com sucesso!");
        },
      )
      .addCase(createCashRegister.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Não foi possível abrir o caixa, tente novamente!");
      })

      // PatchCashClose
      .addCase(patchCashClose.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        patchCashClose.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;

          const updatedCashRegister = action.payload.data;

          const index = state.cashier.data.cashRegisters.findIndex(
            (s) => s.id === updatedCashRegister.id,
          );

          if (index !== -1) {
            state.cashier.data.cashRegisters[index] = {
              ...state.cashier.data.cashRegisters[index],
              ...updatedCashRegister,
            };
          }

          toast.success("Caixa fechado com sucesso!");
        },
      )
      .addCase(patchCashClose.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      })

      // PatchCashChange
      .addCase(patchCashChange.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        patchCashChange.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;

          const updatedCashRegister = action.payload.data;

          const index = state.cashier.data.cashRegisters.findIndex(
            (s) => s.id === updatedCashRegister.id,
          );

          if (index !== -1) {
            state.cashier.data.cashRegisters[index] = {
              ...state.cashier.data.cashRegisters[index],
              ...updatedCashRegister,
            };
          }

          toast.success("Troco cadastrado com sucesso!");
        },
      )
      .addCase(patchCashChange.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      })

      // PatchCashWithdrawal
      .addCase(patchCashWithdrawal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        patchCashWithdrawal.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;

          const updatedCashRegister = action.payload.data;

          const index = state.cashier.data.cashRegisters.findIndex(
            (s) => s.id === updatedCashRegister.id,
          );

          if (index !== -1) {
            state.cashier.data.cashRegisters[index] = {
              ...state.cashier.data.cashRegisters[index],
              ...updatedCashRegister,
            };
          }

          toast.success("Sangria cadastrado com sucesso!");
        },
      )
      .addCase(patchCashWithdrawal.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      });
  },
});

export default CashierSlice.reducer;
